"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RootSpectrumPreferenceProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cdsUtils = require("@cbhq/cds-utils");
var _context = require("./context");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/** The top most spectrum provider to be rendered in DevicePreferencesProvider. Can be updated via useRootSpectrumUdpater.  */
const RootSpectrumPreferenceProvider = /*#__PURE__*/(0, _react.memo)(({
  children,
  value
}) => {
  const _useState = (0, _react.useState)(value !== null && value !== void 0 ? value : 'system'),
    spectrum = _useState[0],
    setSpectrum = _useState[1];
  const context = (0, _react.useContext)(_context.RootSpectrumPreferenceContext);

  /** Guarantee we only have a single RootScaleContext  */
  if (!(0, _cdsUtils.isProduction)() && context) {
    // eslint-disable-next-line no-console
    console.error('Multiple RootSpectrumPreferenceProviders were rendered and there should only be one. Ensure there is a single RootSpectrumPreferenceProvider to resolve.');
  }
  return /*#__PURE__*/_react.default.createElement(_context.RootSpectrumPreferenceContext.Provider, {
    value: spectrum
  }, /*#__PURE__*/_react.default.createElement(_context.RootSpectrumPreferenceUpdaterContext.Provider, {
    value: setSpectrum
  }, children));
});
exports.RootSpectrumPreferenceProvider = RootSpectrumPreferenceProvider;
RootSpectrumPreferenceProvider.displayName = 'RootSpectrumPreferenceProvider';